/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Container, Segment, Header, Form, FormInput, Button, Message, Popup, Icon, Table } from 'semantic-ui-react';

import { REGEX_PATTERNS, base } from '../../../config/constants';
import { AlertBox, ConfirmBox, SelectBox, setAlertMsg } from '../../../components/Modals/index';

export default class AddTheme extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    manageableThemes: PropTypes.array,
    bringStateUp: PropTypes.func,
    themeType: PropTypes.string,
  }

  static defaultProps = {
    habilitations: { uid: null },
    history: null,
    manageableThemes: [],
    bringStateUp: () => null,
    themeType: 'themes',
  }

  constructor(props) {
    super(props);
    this.state = {
      addingTheme: false,
    };
    this.fields = {
      id: null,
      nom: null,
    };
  }

  getThemeTypeLabel = (cap = false, plural = false) => {
    switch (this.props.themeType) {
      case 'themes':
        return `${(cap ? 'P' : 'p')}rofession${(plural ? 's' : '')}`;
      case 'citizenly':
        return `${(cap ? 'C' : 'c')}ommune${(plural ? 's' : '')}`;
      case 'elected':
        return `${(cap ? 'C' : 'c')}irconscription${(plural ? 's' : '')}`;
      default:
        return '[THEME]';
    }
  }

  resetComponent = () => {
    this.fields = {
      id: null,
      nom: null,
    };
  }

  handleSubmit = () => {
    if (!this.fields.id || !REGEX_PATTERNS.technicalId.test(this.fields.id)) {
      return this.setState(setAlertMsg(
        null,
        `Impossible de créer la ${this.getThemeTypeLabel()}`,
        'Vous devez définir un identifiant composé de caractères parmis: alpha-numériques non accentués (a-z, 0-9),' +
        ' tiret haut ("-" ou "tiret du 6"), tiret bas ("_", ou "underscore", ou "tiret du 8").',
      ));
    }

    if (!this.fields.nom || this.fields.nom.length < 2) {
      return this.setState(setAlertMsg(
        null,
        `Impossible de créer la ${this.getThemeTypeLabel()}`,
        `Vous devez définir un nom d'affichage faisant au moins 2 caractères pour cette ${this.getThemeTypeLabel()}.<br/>
         Il s'agit du nom qui sera visible par les utilisateurs finaux.`,
      ));
    }

    if (_.find(this.state.manageableThemes, theme => theme.key === this.fields.id)) {
      return this.setState(setAlertMsg(
        null,
        `Impossible de créer la ${this.getThemeTypeLabel()}`,
        `Cet identifiant technique est déjà utilisé par une autre ${this.getThemeTypeLabel()}.<br/>Veuillez en choisir un autre.`,
      ));
    }

    return base.post(
      `${this.props.themeType}/${this.fields.id}`,
      { data: { nom: this.fields.nom } },
    ).then(() => {
      this.props.bringStateUp(setAlertMsg(
        null,
        `${this.getThemeTypeLabel(true)} ajoutée`,
        `Cette ${this.getThemeTypeLabel()} a bien été ajoutée`,
        'success',
      ));
      this.resetComponent();
    });
  }

  render() {
    const existing = this.props.manageableThemes;
    const sIfMultiple = existing.length > 1 ? 's' : '';

    return (
      <Container>
        <Segment basic>
          <Container text>
            <Segment basic>
              <Header textAlign="center" size="small">
                Ajouter une nouvelle {this.getThemeTypeLabel()}
              </Header>
              <Message info icon size="small">
                <Icon name="info circle" />
                <Message.Content>
                  Dans un premier temps, vous ne devez saisir que l'identifiant technique et le nom d'affichage pour
                  créer une {this.getThemeTypeLabel()}.<br />
                  La {this.getThemeTypeLabel()} sera créée <strong>invisible par défaut</strong>.<br />
                  Vous pourrez ensuite configurer les autres paramètres  via le menu
                  <strong> <Link to={`/${this.props.themeType}/manage`}>configuration</Link></strong>
                </Message.Content>
              </Message>
              <Form size="large" onSubmit={this.handleSubmit}>
                <Segment>
                  <Popup
                    flowing
                    trigger={(
                      <FormInput
                        fluid
                        autoFocus
                        icon="hashtag"
                        iconPosition="left"
                        onChange={(e) => {
                          this.fields.id = e.target.value.toLowerCase();
                        }}
                        placeholder="identifiant_technique"
                      />
                    )}
                  >
                    Il s'agit d'un identifiant technique qui doit permettre d'identifier de manière unique
                    cette {this.getThemeTypeLabel()}.
                    <br />
                    <br />
                    Cet identifiant peut contenir les caractères suivants:<br />
                    - <strong>alpha-numérique non accentué</strong> (a-z, 0-9),<br />
                    - <strong>tiret haut</strong> ("-" ou "<em>tiret du 6</em>"),<br />
                    - <strong>tiret bas</strong> ("_", ou "<em>underscore</em>", ou "<em>tiret du 8</em>")
                  </Popup>
                  <Popup
                    flowing
                    trigger={(
                      <FormInput
                        fluid
                        icon="globe"
                        iconPosition="left"
                        onChange={(e) => {
                          this.fields.nom = e.target.value;
                        }}
                        placeholder="Nom d'affichage"
                      />
                    )}
                  >
                    Il s'agit du nom qui sera <strong>visible par les utilisateurs finaux</strong>.
                  </Popup>
                  <Button
                    fluid
                    color="green"
                    type="submit"
                    icon="add"
                    content={`Ajouter cette ${this.getThemeTypeLabel()}`}
                    loading={this.state.addingTheme}
                  />
                </Segment>
              </Form>
            </Segment>
            <Segment basic>
              <Header
                content={`${existing.length} ${this.getThemeTypeLabel(false, existing.length > 1)} existante${sIfMultiple}`}
                textAlign="center"
                size="small"
              />
              <Table
                tableData={
                  _.map(this.props.manageableThemes, t => ({
                    id: t.key,
                    nom: t.nom,
                  }))
                }
                renderBodyRow={t => (
                  <Table.Row key={t.id}>
                    <Table.Cell>{t.id}</Table.Cell>
                    <Table.Cell>{t.nom}</Table.Cell>
                  </Table.Row>
                )}

              />
            </Segment>
          </Container>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
        <SelectBox
          propagateClosure={() => this.setState({ pick: { open: false } })}
          {...this.state.pick}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/_common/AddTheme.js